const pedigreeMutations = {
	FETCH_PEDIGREE: 'FETCH_PEDIGREE',
	FETCH_SPECIMEN_FOR_UPDATE: 'FETCH_SPECIMEN_FOR_UPDATE',
};

export default Object.freeze({
	...pedigreeMutations,
});
